<template>
  <div>

    <form
      class="needs-validation"
      @submit.prevent="submitFormScheudle(object)"
    >
      <div class="row">
        <div class="col-md-5">
          <label class="mt-3">Από*</label>
          <b-form-input
            id="start-date"
            v-model="start_date"
            type="date"
            placeholder="DD-MM-YYYY"
            autocomplete="off"
            :class="{ 'is-invalid': errors.start_date }"
          ></b-form-input>
          <div
            v-if="errors.start_date"
            class="invalid-feedback"
          >{{ errors.end_date }}</div>
        </div>
        <div class="col-md-5">
          <label class="mt-3">Μέχρι*</label>
          <b-form-input
            id="end-date"
            v-model="end_date"
            type="date"
            placeholder="DD-MM-YYYY"
            autocomplete="off"
            :class="{ 'is-invalid': errors.end_date }"
          ></b-form-input>

          <div
            v-if="errors.end_date"
            class="invalid-feedback"
          >{{ errors.end_date }}</div>
        </div>
        <div class="col-md-8">
          <label class="mt-3">Ημέρες</label>
          <multiselect
            required
            v-model="weekdaySelected"
            :options="weekdayOptions"
            track-by="id"
            label="weekday"
            multiple
            placeholder="Επιλέξτε Ημέρες"
            selectLabel="Eπιλογή Ημέρα"
            selectedLabel="Επιλέχθηκε"
            deselectLabel="Αποεπιλογή"
          >
          </multiselect>
        </div>
        <div class="col-md-5">
          <label class="mt-3">Ώρα έναρξης</label>
          <date-picker
            v-model="start_time"
            format="HH:mm"
            value-type="format"
            type="time"
            placeholder="HH:mm"
            @change="handleStartTimeChange"
            :class="{ 'is-invalid': errors.start_time }"
          ></date-picker>
        </div>
        <div class="col-md-5">
          <label class="mt-3">Ώρα λήξης</label>
          <date-picker
            v-model="end_time"
            format="HH:mm"
            value-type="format"
            type="time"
            placeholder="HH:mm"
            @change="handleEndTimeChange"
            :class="{ 'is-invalid': errors.end_time }"
          ></date-picker>
          <div
            v-if="errors.end_time"
            class="invalid-feedback"
          >{{ errors.end_time }}</div>
        </div>
        <div class="col-md-8 mt-3">
          <div class="mt-3">
            <label>Νυχτερινό ωράριο</label>
            <b-form-checkbox
              v-model="is_night_shift"
              class="mb-3 custom-checkbox"
              plain
            ></b-form-checkbox>
          </div>
        </div>
      </div>
      <br>
      <br>
      <button
        class="btn btn-primary"
        type="submit"
      >
        Ολοκλήρωση
      </button>
    </form>
  </div>
</template>



<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import session from "../../../../../api/session";
import { weekDayOptionsMap } from "../../utils";
import { eventCreate } from "../../../../../eventspy.js";

export default {
  components: {
    Multiselect,
    DatePicker,
    // EditSchedule
  },
  props: {
    object: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      start_date: this.object.start_date || "",
      end_date: this.object.end_date || "",
      weekdaySelected: this.mapWeekdaySelected(this.object.weekdays || []),
      start_time: this.object.start_time || "",
      end_time: this.object.end_time || "",
      is_night_shift: this.object.is_night_shift || false,
      errors: {
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
      },
    };
  },
  computed: {
    weekdayOptions() {
      return weekDayOptionsMap;
    },
  },
  methods: {
    mapWeekdaySelected(selectedIds) {
      return weekDayOptionsMap.filter((e) => selectedIds.includes(e.id));
    },
    validateDates() {
      let isValid = true;

      if (
        !moment(this.end_date, "YYYY-MM-DD").isSameOrAfter(
          moment(this.start_date, "YYYY-MM-DD"),
          "day"
        )
      ) {
        this.errors.end_date =
          "Η ημερομηνία λήξης δεν μπορεί να είναι προγενέστερη από την ημερομηνία έναρξης.";
        isValid = false;
      } else {
        this.errors.end_date = "";
      }

      if (!this.is_night_shift) {
        if (
          this.start_time &&
          this.end_time &&
          moment(this.start_time, "HH:mm").isSameOrAfter(
            moment(this.end_time, "HH:mm"),
            "minute"
          )
        ) {
          this.errors.end_time =
            "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
          isValid = false;
        } else {
          this.errors.end_time = "";
        }
      } else {
        if (
          this.start_time &&
          this.end_time &&
          moment(this.start_time, "HH:mm").isSameOrBefore(
            moment(this.end_time, "HH:mm"),
            "minute"
          )
        ) {
          this.errors.end_time =
            "Η ώρα λήξης πρέπει να είναι νωρίτερα από την ώρα έναρξης για τη νυχτερινή βάρδια.";
          isValid = false;
        } else {
          this.errors.end_time = "";
        }
      }

      return isValid;
    },
    submitFormScheudle() {
      if (!this.validateDates()) {
        return;
      }

      const data = {
        person: this.object.person,
        start_date: this.start_date,
        end_date: this.end_date,
        start_time: this.start_time,
        end_time: this.end_time,
        weekdays: this.weekdaySelected,
        is_night_shift: this.is_night_shift,
      };

      if (this.status === "update") {
        this.updateSchedule(data);
      } else if (this.status === "create") {
        data["person"] = this.$route.params.id;
        this.createSchedule(data);
      } else {
        return;
      }
    },

    createSchedule(data) {
      data["weekdays"] = this.weekdaySelected.map((e) => e.id);
      session
        .post("api/user/schedule/create/", data)
        .then(() => {
          eventCreate(
            `Προσθήκη Προγραμματος
               ${JSON.stringify(data)}`,
            1
          );
          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση`,
            msg: "Τα Ωράριο Εργασίας προστέθηκε επιτυχώς!",
            style: {
              backgroundColor: "#4fd69c",
              width: "550px",
            },
            progressbar: false,
            timeout: 3500,
          });
          setTimeout(() => {
            this.$emit("CreateSchedule", this.status);
          }, 1000);
        })
        .catch((e) => {
          console.log(e);
          this.$toastr.e(JSON.stringify(e.response.data));
          return;
        });
    },
    updateSchedule(data) {
      session
        .put(`api/user/schedule/${this.object.id}/update/`, data)
        .then((resp) => {
          eventCreate(
            `Επεξεργασια Προγραμματος
            ${JSON.stringify(this.object)}
            -----------------------------------------------------

            ${JSON.stringify(resp.data)}`,
            2
          );

          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση`,
            msg: "Τα Ωράριο Εργασίας ανανεώθηκε επιτυχώς!",
            style: {
              backgroundColor: "#4fd69c",
              width: "550px",
            },
            progressbar: false,
            timeout: 3500,
          });

          setTimeout(() => {
            this.$emit("UpdatedSchedule", this.object.id);
          }, 1000);
        })
        .catch((e) => {
          console.log(e);
          this.$toastr.e(JSON.stringify(e.response.data));
          return;
        });
    },

    handleStartTimeChange() {
      if (
        !this.is_night_shift &&
        this.start_time &&
        this.end_time &&
        moment(this.start_time, "HH:mm").isSameOrAfter(
          moment(this.end_time, "HH:mm"),
          "minute"
        )
      ) {
        this.errors.end_time =
          "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
      } else {
        this.errors.end_time = "";
      }
    },
    handleEndTimeChange() {
      if (
        !this.is_night_shift &&
        this.start_time &&
        this.end_time &&
        moment(this.end_time, "HH:mm").isSameOrBefore(
          moment(this.start_time, "HH:mm"),
          "minute"
        )
      ) {
        this.errors.end_time =
          "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
      } else {
        this.errors.end_time = "";
      }
    },
  },
};
</script>

<style scoped>
::v-deep .custom-checkbox .form-check-input {
  width: 30px;
  height: 30px;
}
</style>